(function ($, undefined) {
  /*============================================
  Swipers
  ==============================================*/
  $(function () {
    new Swiper(".workshop-swiper", {
      slidesPerView: 'auto',
      spaceBetween: 24,
      freeMode: true,
      pagination: {
        el: ".section-workshop .b-swiper-controls__pagination",
        type: "fraction",
        formatFractionCurrent: function (number) {
          return number < 10 ? '0' + number : number;
        },
        formatFractionTotal: function (number) {
          return number < 10 ? '0' + number : number;
        },
        renderFraction: function (currentClass, totalClass) {
          return '<span class="' + currentClass + '"></span>'
            + '<span class="b-swiper-controls__pagination-sep">/</span>'
            + '<span class="' + totalClass + '"></span>';
        },
      },
      navigation: {
        nextEl: ".section-workshop .swiper-button-next",
        prevEl: ".section-workshop .swiper-button-prev",
      },
    });

    new Swiper(".services-swiper", {
      slidesPerView: 'auto',
      spaceBetween: 24,
      freeMode: true,
      pagination: {
        el: ".section-services .b-swiper-controls__pagination",
        type: "fraction",
        formatFractionCurrent: function (number) {
          return number < 10 ? '0' + number : number;
        },
        formatFractionTotal: function (number) {
          return number < 10 ? '0' + number : number;
        },
        renderFraction: function (currentClass, totalClass) {
          return '<span class="' + currentClass + '"></span>'
            + '<span class="b-swiper-controls__pagination-sep">/</span>'
            + '<span class="' + totalClass + '"></span>';
        },
      },
      navigation: {
        nextEl: ".section-services .swiper-button-next",
        prevEl: ".section-services .swiper-button-prev",
      },
    });

    // Related products — single-product PDP (max 3 cards).
    // Static 3-col grid at xl (enabled:false hands layout to CSS), 2-per-view
    // carousel on md/lg, 1-per-view on mobile. Controls scoped to the section.
    new Swiper(".related-swiper", {
      slidesPerView: 1,
      spaceBetween: 24,
      breakpoints: {
        768: { slidesPerView: 2, enabled: true },
        1200: { slidesPerView: 3, enabled: false },
      },
      navigation: {
        nextEl: ".remote-service-related .swiper-button-next",
        prevEl: ".remote-service-related .swiper-button-prev",
      },
      pagination: {
        el: ".remote-service-related .b-swiper-controls__pagination",
        type: "fraction",
        formatFractionCurrent: function (number) {
          return number < 10 ? '0' + number : number;
        },
        formatFractionTotal: function (number) {
          return number < 10 ? '0' + number : number;
        },
        renderFraction: function (currentClass, totalClass) {
          return '<span class="' + currentClass + '"></span>'
            + '<span class="b-swiper-controls__pagination-sep">/</span>'
            + '<span class="' + totalClass + '"></span>';
        },
      },
    });
  });

  // Mobile menu accordion
  document.querySelectorAll('.mobile-menu-modal__chevron').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const subnav = this.closest('.has-children').querySelector('.mobile-menu-modal__subnav');
      const isOpen = subnav.classList.toggle('open');
      this.classList.toggle('open', isOpen);
      this.setAttribute('aria-expanded', isOpen);
    });
  });

  // FAQ accordion
  document.querySelectorAll('.faq-item__head').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = this.closest('.faq-item');
      if (!item.querySelector('.faq-item__body')) return;
      const willOpen = !item.classList.contains('is-open');
      item.parentElement.querySelectorAll('.faq-item.is-open').forEach(function (open) {
        open.classList.remove('is-open');
        const head = open.querySelector('.faq-item__head');
        if (head) head.setAttribute('aria-expanded', 'false');
      });
      item.classList.toggle('is-open', willOpen);
      this.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  });

  // Item card modal
  $(document).on('click', '.js-item-card', function () {
    var $card  = $(this);
    var title  = $card.data('item-title');
    var $modal = $('#item-modal');

    $modal.find('.item-modal__item-name').val(title || '');

    bootstrap.Modal.getOrCreateInstance($modal[0]).show();
  });

  // Gallery thumbnail swap — single-product page (PROD-02)
  // Fires on click of .remote-service__thumb buttons; swaps #rs-main-img src + alt.
  // is-active class marks the selected thumbnail (styled in remote-service.scss).
  // No inline script in Twig — handler lives here per CLAUDE.md JavaScript conventions.
  document.querySelectorAll('.remote-service__thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var main = document.getElementById('rs-main-img');
      if (main) {
        main.src = btn.dataset.mainSrc;
        main.alt = btn.dataset.mainAlt;
      }
      document.querySelectorAll('.remote-service__thumb').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
    });
  });

})(jQuery);
